import mock from './mock'


import './data/table/index.js'
import './data/data-list/index.js'
import './data/user-management/index.js'
import './data/user/index.js'
import './data/service-tickets/index.js'

mock.onAny().passThrough() // forwards the matched request over network
